import { IconCopy, Popup, Select } from '@ui/src';
import isEqual from 'lodash.isequal';
import { NewApplicationStatus } from '../../types';
import { NewApplicationTopPopupsTypes } from '../types';

import cn from '../styles.module.css';

const NewApplicationTopPopups = ({
  setRejectNotifyPopupVisible,
  setTextareaIsVisible,
  rejectNotifyPopupVisible,
  setResponsiblePopupVisible,
  setWithStatusChange,
  withStatusChange,
  setReviewEmployeeAction,
  newApplicationInfo,
  selectedResponsible,
  onAddResponsible,
  addResponsibleInProgress,
  setReviewEmployeeInProgress,
  responsiblePopupVisible,
  setSelectedResponsible,
  employeesList,
  setPopupVisible,
  onRejectAplication,
  rejectInProgress,
  popupVisible,
  setResetPopupVisible,
  resetPopupUpVisible,
  resetCopyIsSuccess,
  link,
  token,
  onResetCopy,
}: NewApplicationTopPopupsTypes) => (
  <>
    <Popup
      title="Required comment"
      description="To reject the application, you must comment on the reason for the rejection."
      onCancelClick={() => setRejectNotifyPopupVisible(false)}
      onOkClick={() => {
        setTextareaIsVisible(true);
        setRejectNotifyPopupVisible(false);
      }}
      cancelButtonText="Cancel"
      okButtonText="Add comment"
      isVisible={rejectNotifyPopupVisible}
    />
    <Popup
      title="Select responsible for review"
      onCancelClick={() => {
        setResponsiblePopupVisible(false);
        setWithStatusChange(false);
      }}
      onOkClick={() => {
        if (!withStatusChange) {
          setReviewEmployeeAction();
        } else {
          const body: {
            status: NewApplicationStatus;
            id?: string;
          } = {
            status: NewApplicationStatus.REVIEW_IN_PROGRESS,
          };

          if (
            (newApplicationInfo?.reviewEmployee &&
              !isEqual(
                selectedResponsible,
                newApplicationInfo?.reviewEmployee.id,
              )) ||
            !newApplicationInfo?.reviewEmployee
          ) {
            body.id = selectedResponsible;
          }

          onAddResponsible(body);
        }
      }}
      cancelButtonText="Cancel"
      okButtonText={
        addResponsibleInProgress || setReviewEmployeeInProgress
          ? 'Loading...'
          : 'Confirm'
      }
      isVisible={responsiblePopupVisible}
      isLoading={addResponsibleInProgress || setReviewEmployeeInProgress}
      popupClassName={cn.responsiblePopup}
    >
      <div className={cn.responsibleSelectWrapper}>
        <Select
          name="selectedResponsible"
          value={selectedResponsible}
          title="Responsible for review"
          placeholder="Select user"
          onChange={(e) => setSelectedResponsible(e.target.value as string)}
          list={employeesList}
        />
      </div>
    </Popup>
    <Popup
      title="Reject application?"
      description="Application will be closed"
      onCancelClick={() => setPopupVisible(false)}
      onOkClick={() => {
        onRejectAplication();
      }}
      cancelButtonText="Cancel"
      okButtonText={rejectInProgress ? 'Loading...' : 'Reject'}
      isVisible={popupVisible}
    />
    <Popup
      title="Reset customer password"
      description="Send this link to the user for password recovery"
      onCancelClick={() => setResetPopupVisible(false)}
      isVisible={resetPopupUpVisible}
      parent={document.getElementById('password-popup') as HTMLElement}
    >
      <div className={cn.applicationResetPasswordLink}>
        <div
          className={`${cn.copySuccess} ${
            resetCopyIsSuccess ? cn.visible : ''
          }`}
        >
          Copied!
        </div>
        <span>{`${link}/auth/reset-password?token=${token}`}</span>
        <button
          type="button"
          className={cn.copyButton}
          onClick={onResetCopy}
          aria-label="Copy link button"
        >
          <IconCopy />
        </button>
      </div>
    </Popup>
  </>
);

export default NewApplicationTopPopups;
